// extracted by mini-css-extract-plugin
export default {"post":"CardsText_post__j4Zvq","tal":"CardsText_tal__3L2-8","tac":"CardsText_tac__nbt0K","tar":"CardsText_tar__32xfl"};